export default __webpack_public_path__ + "static/media/categoria_banco.2f289a46.svg";